export const PEELING_WASTAGE_REQUEST = "PEELING_WASTAGE_REQUEST";
export const PEELING_WASTAGE_SUCCESS = "PEELING_WASTAGE_SUCCESS";
export const PEELING_WASTAGE_FAILED = "PEELING_WASTAGE_FAILED";
